import { render, staticRenderFns } from "./MarketWayGoods.vue?vue&type=template&id=3c1a4174&scoped=true"
import script from "./MarketWayGoods.vue?vue&type=script&lang=js"
export * from "./MarketWayGoods.vue?vue&type=script&lang=js"
import style0 from "./MarketWayGoods.vue?vue&type=style&index=0&id=3c1a4174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a4174",
  null
  
)

export default component.exports